<script setup>
import { ref, computed } from "vue";
import Logo from "@/components/global/Logo";
import { useUserStore } from "@/stores";
import { helpers, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { useRoute } from "vue-router";

const userStore = useUserStore();
const route = useRoute();

const form = ref({
  password: null,
});

const rules = {
  password: {
    required: helpers.withMessage("Password is required", required),
  },
};

const v$ = useVuelidate(rules, form);

const getErrorMessages = (field) =>
  computed(() =>
    v$.value[field]?.$error
      ? v$.value[field].$errors.map((e) => e.$message)
      : []
  );

const showPass = ref(false);

async function handleResetClick() {
  const isValid = await v$.value.$validate();
  if (isValid) {
    const data = {
      password: form.value.password,
      key: route.query.key,
    };
    await userStore.resetPassword(data);
  }
}
</script>

<template>
  <div
    class="d-flex flex-column justify-center align-center container-background h-100"
  >
    <div class="mb-5" style="width: 15%">
      <Logo />
    </div>
    <v-card class="pa-5" min-width="400px">
      <v-form>
        <div class="d-flex flex-column gap-10">
          <v-text-field
            id="id"
            v-model="form.password"
            name="password"
            :type="showPass ? 'text' : 'password'"
            label="Password"
            variant="outlined"
            :append-inner-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            :error-messages="getErrorMessages('password').value"
            hide-details="auto"
            @click:append-inner="showPass = !showPass"
            @blur="v$.password.$touch()"
          />
          <div class="mb-5 d-flex justify-space-between align-center">
            <v-btn color="primary" @click="handleResetClick()">
              Reset your password
            </v-btn>
          </div>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<style lang="scss" scoped>
.container-background {
  background: rgb(var(--v-theme-primary));
  .v-form {
    a {
      color: rgb(var(--v-theme-primary));
    }
  }
}
</style>
